import { Skeleton } from 'primereact/skeleton';
import classes from './loading.module.scss';

const TMSDataTableLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default TMSDataTableLoadingSkeleton;
